// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-team-members-modal__container {
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    margin-bottom: var(--space-and-half);
    margin-right: var(--space);
}

.tournament-team-members-modal__team {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.tournament-team-members-modal__team .icon-ball {
    font-size: 38px;
    padding: 4px;
    border-radius: 50%;
    color: var( --white-color );
    margin: var(--space-half-quarter) 0;
}

.tournament-team-members-modal__team img {
    width: 46px;
    height: 46px;
    margin: var(--space-half-quarter) 0;
    border-radius: 50%;
    
}

.tournament-team-members-modal__team .baloa-names {
    margin-bottom: var(--space-half-quarter);
    color: var(--primary-very-dark-color);
}

.tournament-team-members-modal__team .baloa-username {
    margin-bottom: var(--space-half-quarter);
    color: var(--primary-dark-color);
}

.tournament-team-members-modal__team .button,
.tournament-team-members-modal__members .button {
    padding: 6px 28px;
    border-radius: var(--space-x3);
    border: 3px solid var(--new-green-color);
    min-width: 132px;
    grid-template-columns: none;
    grid-template-areas: none;
}

.tournament-team-members-modal {
    display: flex;
    align-items: center;
}

.tournament-team-members-modal .icon-ball {
    font-size: 28px;
    padding: 4px;
    border-radius: 50%;
    color: var( --white-color );
    margin-right: var(--space-half-quarter);
}

.tournament-team-members-modal img {
    width: 36px;
    height: 36px;
    margin-right: var(--space-half-quarter);
    border-radius: 50%;
}

.tournament-team-members-modal .hubicon-id_card {
    font-size: 22px;
    margin-left: auto;
    cursor: pointer;
}

.tournament-team-members-modal .hubicon-id_card::before {
    color: var(--new-green-color);
}

.baloa-table.tournament-team-members-modal__members-title {
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    padding: var(--space) 0 var(--space-half) 0;
    border-bottom: 1px solid var(--new-gray-background-color);
    margin-bottom: var(--space);
}

.tournament-team-members-modal__team__cotainer .modal2__content {
    padding: var(--space-x2);
}

.tournament-team-members-modal__download-buttons {
    display: flex;
    align-items: center;
}

.tournament-team-members-modal_download_template {
    color: var(--new-green-color);
    display: flex;
    gap: var(--space-half);
    padding: var(--space);
    align-items: center;
    cursor: pointer;
    position: relative;
}

.tournament-team-members-modal_download_template .hubicon-roster,
.tournament-team-members-modal_download_template .hubicon-id_card{
    font-size: 22px;
}

.tournament-team-members-modal_download_template_text.baloa-table-column{
    color: var(--new-green-color);
}

.tournament-team-members-modal__members_staff_coach.baloa-table{
    margin-bottom: var(--space-half);
    color: var(--primary-dark-color);
}

.tournament-team-members-modal__info .baloa-username{
    color: var(--primary-dark-color);
    display: flex;
    align-items: center;
    gap: 4px;
}

.tournament-team-members-modal__info .baloa-table {
    color: var(--primary-very-dark-color);
    display: flex;
    align-items: center;
    gap: 4px;
}

.tournament-team-members-modal__info .hubicon-award_star {
    font-size: 16px;
}

.tournament-team-members-modal__options-box {
    position: absolute;
    padding: 8px;
    box-shadow: var(--shadow);
    /* display: flex; */
    flex-direction: column;
    gap: 4px;
    border-radius: 8px;
    top: 46px;
    background-color: var(--white-color);
    left: 10px;
    display: none;
}

.tournament-team-members-modal__options-box .baloa-table a{
    color: var(--primary-very-dark-color);
    text-wrap: nowrap;

}

.tournament-team-members-modal__options-box .baloa-table:hover {
    background: var(--new-background-color);
}

.tournament-team-members-modal__options-box .baloa-table {
    color: var(--primary-very-dark-color);
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
}

.tournament-team-members-modal__options-box.open {
    display: block;
    z-index: 2;
    display: flex;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .tournament-team-members-modal__team__cotainer .modal2__container {
        height: 100%;
        margin: 0;
        max-height: none;
        border-radius: 0;
    }

    .tournament-team-members-modal__team__cotainer .modal2__content{
        height: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-team-members-modal/TournamentTeamMembersModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI;;qCAEiC;IACjC,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;;AAEtB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;IACjB,8BAA8B;IAC9B,wCAAwC;IACxC,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,2CAA2C;IAC3C,yDAAyD;IACzD,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,oCAAoC;IACpC,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;;AAErB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,aAAa;AACjB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,YAAY;QACZ,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".tournament-team-members-modal__container {\n    /* display: flex;\n    align-items: center;\n    justify-content: space-between; */\n    margin-bottom: var(--space-and-half);\n    margin-right: var(--space);\n}\n\n.tournament-team-members-modal__team {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.tournament-team-members-modal__team .icon-ball {\n    font-size: 38px;\n    padding: 4px;\n    border-radius: 50%;\n    color: var( --white-color );\n    margin: var(--space-half-quarter) 0;\n}\n\n.tournament-team-members-modal__team img {\n    width: 46px;\n    height: 46px;\n    margin: var(--space-half-quarter) 0;\n    border-radius: 50%;\n    \n}\n\n.tournament-team-members-modal__team .baloa-names {\n    margin-bottom: var(--space-half-quarter);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-team-members-modal__team .baloa-username {\n    margin-bottom: var(--space-half-quarter);\n    color: var(--primary-dark-color);\n}\n\n.tournament-team-members-modal__team .button,\n.tournament-team-members-modal__members .button {\n    padding: 6px 28px;\n    border-radius: var(--space-x3);\n    border: 3px solid var(--new-green-color);\n    min-width: 132px;\n    grid-template-columns: none;\n    grid-template-areas: none;\n}\n\n.tournament-team-members-modal {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-team-members-modal .icon-ball {\n    font-size: 28px;\n    padding: 4px;\n    border-radius: 50%;\n    color: var( --white-color );\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-team-members-modal img {\n    width: 36px;\n    height: 36px;\n    margin-right: var(--space-half-quarter);\n    border-radius: 50%;\n}\n\n.tournament-team-members-modal .hubicon-id_card {\n    font-size: 22px;\n    margin-left: auto;\n    cursor: pointer;\n}\n\n.tournament-team-members-modal .hubicon-id_card::before {\n    color: var(--new-green-color);\n}\n\n.baloa-table.tournament-team-members-modal__members-title {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    padding: var(--space) 0 var(--space-half) 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    margin-bottom: var(--space);\n}\n\n.tournament-team-members-modal__team__cotainer .modal2__content {\n    padding: var(--space-x2);\n}\n\n.tournament-team-members-modal__download-buttons {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-team-members-modal_download_template {\n    color: var(--new-green-color);\n    display: flex;\n    gap: var(--space-half);\n    padding: var(--space);\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n}\n\n.tournament-team-members-modal_download_template .hubicon-roster,\n.tournament-team-members-modal_download_template .hubicon-id_card{\n    font-size: 22px;\n}\n\n.tournament-team-members-modal_download_template_text.baloa-table-column{\n    color: var(--new-green-color);\n}\n\n.tournament-team-members-modal__members_staff_coach.baloa-table{\n    margin-bottom: var(--space-half);\n    color: var(--primary-dark-color);\n}\n\n.tournament-team-members-modal__info .baloa-username{\n    color: var(--primary-dark-color);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.tournament-team-members-modal__info .baloa-table {\n    color: var(--primary-very-dark-color);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.tournament-team-members-modal__info .hubicon-award_star {\n    font-size: 16px;\n}\n\n.tournament-team-members-modal__options-box {\n    position: absolute;\n    padding: 8px;\n    box-shadow: var(--shadow);\n    /* display: flex; */\n    flex-direction: column;\n    gap: 4px;\n    border-radius: 8px;\n    top: 46px;\n    background-color: var(--white-color);\n    left: 10px;\n    display: none;\n}\n\n.tournament-team-members-modal__options-box .baloa-table a{\n    color: var(--primary-very-dark-color);\n    text-wrap: nowrap;\n\n}\n\n.tournament-team-members-modal__options-box .baloa-table:hover {\n    background: var(--new-background-color);\n}\n\n.tournament-team-members-modal__options-box .baloa-table {\n    color: var(--primary-very-dark-color);\n    border-radius: 8px;\n    padding: 8px;\n    cursor: pointer;\n}\n\n.tournament-team-members-modal__options-box.open {\n    display: block;\n    z-index: 2;\n    display: flex;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .tournament-team-members-modal__team__cotainer .modal2__container {\n        height: 100%;\n        margin: 0;\n        max-height: none;\n        border-radius: 0;\n    }\n\n    .tournament-team-members-modal__team__cotainer .modal2__content{\n        height: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
